export type Environment = "local" | "dev" | "uat" | "production";

/**
 * Current environment setting.
 * Change this value for different deployments:
 * - "local" for local development (uses microservice-specific ports)
 * - "dev" for development environment (api-newdev.fundedhere.com)
 * - "uat" for UAT environment (api-uat.fundedhere.com)
 * - "production" for production environment (api.fundedhere.com)
 */
export const ENV: Environment = "dev";
